import script from "./StockIndividual.vue?vue&type=script&lang=ts&setup=true"
export * from "./StockIndividual.vue?vue&type=script&lang=ts&setup=true"

import "./StockIndividual.vue?vue&type=style&index=0&id=6add8b32&lang=scss&scoped=true"

import exportComponent from "/home/kenddriz/Public/locaa/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6add8b32"]])

export default __exports__